import React from 'react';
import Header from "../../components/header";
import Footer from "../../components/footer";
import SideBar from '../../components/sidebar';
import $ from 'jquery';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getFacilityRecordReqList, approveStatus, declineStatus } from "../../services/facility/action";
import { viewRequestInfo } from "../../services/common/action";
import { NavLink } from "react-router-dom";
import { footer } from "../../components/footerSize";
import Pagination from '../common/pagination';
import DeleteModel from '../common/Model/deleteModel';
import moment from "moment";
import ReactHTMLTableToExcel from 'react-html-table-to-excel';

class FacilityHome extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            facilityReqInfoList: [],
            openPopUp: false,
            facilityName: "",
            mobile: "",
            email: "",
            address: "",
            address2: "",
            city: "",
            faciState: "",
            doctorLastName: "",
            firstName: "",
            lastName: "",
            extraCost: "",
            fedexCost: "",
            finalCost: "",
            pageCost: "",
            pageCount: "",
            serviceCharge: "",
            upchargeCost: "",
            pageOfItems: [],
            requestId: "",
            openPopUpDel: false,
            patientName: "",
            records: [],
            dateOfBirth: "",
            patientPhone: "",
            reqUserType: "",
            otherRequestorDocURL: "",
            openPopUpDecline: false,
            exportModal:false,
            thirdPartyRequestId : "",
            createdDate:""
        }
    }

    componentDidMount() {
        // onDocumentReady function bind
        $(document).ready(function () {
            footer("#content");
        });

        // onResize bind of the function
        $(window).resize(function () {
            footer("#content");
        });

        // function to set the height on fly
        function autoHeight() {
            $('.content').css('min-height', 0);
            $('.content').css('min-height', (
                $(document).height() + 32
                - $('.dashHeader').height()
                - $('.footer-section').height()

            ));
            // alert($(document).height() +'-'+ $('.dashHeader').height() +'-'+ $('.footer-section').height());
        }

        // onDocumentReady function bind
        $(document).ready(function () {
            autoHeight();
        });

        // onResize bind of the function
        $(window).resize(function () {
            autoHeight();
        });
        let access_token = this.props.loginDetails;
        let userId = this.props.profileDetails.commonUser.userId;

        this.props.getFacilityRecordReqList(access_token, userId);

    }

    onChangePage = (pageOfItems) => {
        // update state with new page of items
        this.setState({ pageOfItems: pageOfItems });
    }


    componentWillReceiveProps = nextProps => {

        if (nextProps.facilityReqInfoStatus) {
            if (nextProps.facilityReqInfoList) {

                let facilityReqInfoList = nextProps.facilityReqInfoList.facilityReqInfoList;
                this.setState({
                    facilityReqInfoList
                })

            }
        }
        if (nextProps.viewRequestInfoStatus) {
            let reqRecordInfo = nextProps.viewRequestInfoDetails.requestInfoDetailes
            this.appendToModelReq(reqRecordInfo);
        }
    }

    appendToModelReq = (req) => {

        let extraCost = req.extraCost ? req.extraCost : "";
        let fedexCost = req.fedexCost ? req.fedexCost : "";
        let finalCost = req.finalCost ? req.finalCost : "";
        let pageCost = req.pageCost ? req.pageCost : "";
        let pageCount = req.pageCount ? req.pageCount : "";
        let serviceCharge = req.serviceCharge ? req.serviceCharge : "";
        let upchargeCost = req.upchargeCost ? req.upchargeCost : "";
        let firstName = req.firstName ? req.firstName : "";
        let lastName = req.lastName ? req.lastName : "";
        let patientName = firstName + " " + lastName;
        let thirdPartyRequestId = req.thirdPartyRequestId ? req.thirdPartyRequestId : "";
        let createdDate =req.createdDate ? moment(req.createdDate).format('MMM Do YYYY') : "";
        let records = req.records ? req.records : [];
        let dateOfBirth = req.dateOfBirth ? req.dateOfBirth : "";
        let patientPhone = req.mobile ? req.mobile : "";
        let reqUserType = req.userType ? req.userType : "";
        let otherRequestorDocURL = req.otherRequestorDocURL ? req.otherRequestorDocURL : ""
        this.setState({
            thirdPartyRequestId,
            createdDate,
            extraCost,
            fedexCost,
            finalCost,
            pageCost,
            pageCount,
            serviceCharge,
            upchargeCost,
            patientName,
            records,
            dateOfBirth,
            patientPhone,
            reqUserType,
            otherRequestorDocURL,
        })
    }

    appendToModel = (req) => {

        let facilityName = req.facilityName ? req.facilityName : "";
        let mobile = req.mobile ? req.mobile : "";
        let email = req.patientEmail ? req.patientEmail : "";
        let faciState = req.faciState ? req.faciState : "";
        let address = req.address ? req.address : "";
        let address2 = req.address2 ? req.address2 : "";
        let city = req.faciCity ? req.faciCity : "";
        let doctorLastName = req.doctorLastName ? req.doctorLastName : ""
        let firstName = req.patientFirstName ? req.patientFirstName : "";
        this.setState({
            firstName,
            facilityName,
            mobile,
            email,
            address,
            address2,
            city,
            faciState,
            doctorLastName,

        })
    }
    viewDetails = (e, req) => {
        e.preventDefault();
        let access_token = this.props.loginDetails;
        this.appendToModel(req);
        let payload = {
            requestId: req.Id
        }

        this.setState({
            openPopUp: true
        })
        this.props.viewRequestInfo(access_token, payload)

    }
    openPopDel = (id) => {
         this.setState({
            openPopUpDel: true,
            requestId: id,

        })
    }
    approveStatus = (id) => {
        this.setState({
            openPopUpDel: false,
        })
        let access_token = this.props.loginDetails;

        let userId = this.props.profileDetails.commonUser.userId;
        this.props.approveStatus(access_token, id, userId)
    }

    closePopDel = () => {
        this.setState({
            openPopUpDel: false,
        })
    }

    openPopDecline = (id) => {
         this.setState({
            openPopUpDecline: true,
            requestId: id,

        })
    }

    declineStatus = (id) => {
        this.setState({
            openPopUpDecline: false,
        })
        let access_token = this.props.loginDetails;

        let userId = this.props.profileDetails.commonUser.userId;
        this.props.declineStatus(access_token, id, userId)
    }
    closePopDecline = () => {
        this.setState({
            openPopUpDecline: false,
        })
    }
 


    render() {

        let {
            facilityName,
            mobile,
            email,
            address,
            address2,
            city,
            faciState,
            doctorLastName,
            firstName,
            lastName,
            extraCost,
            fedexCost,
            finalCost,
            pageCost,
            pageCount,
            serviceCharge,
            upchargeCost,
            openPopUpDel,
            requestId,
            patientName,
            dateOfBirth,
            patientPhone,
            reqUserType,
            records,
            otherRequestorDocURL,
            exportModal,
            facilityReqInfoList,
            pageOfItems,
            thirdPartyRequestId,
            createdDate

        } = this.state
        
        if(exportModal){
            pageOfItems   = facilityReqInfoList
        }
         return (
            <>

                <Header status={"afterLogin"} routes={[{ "name": "Home", "route": "/FacilityHome", }]} />
                <div className="content">
                    <div className="contentSection" id="content">
                        <div className="container-fluid">
                            {/* <div className="titleContent">
                          <ul className="breadcrumb">
                              <li><a href="#">Practice</a></li>
                              <li className="active"><NavLink to="/FacilityHome">Home</NavLink></li>
                            </ul>
                    
                      </div> */}
                            <div className="bodyContent">

                                <div className="row">
                                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">

                                        <div className="titleBg">
                                            <h4>Requested Records</h4>
                                        </div>
                                        <button onClick={()=>this.setState({exportModal : true})} className="btn submit-btn" > Export </button>
                                       
                                        <div  className="table-responsive">
                                            <table id="table-to-xls" className="table commonTable">
                                                <thead>
                                                    <tr>
                                                        <th>Request Id</th>
                                                        <th>Status</th>
                                                        <th>Date of Requested</th>
                                                        <th>Date of completion</th>
                                                        <th>Requested by</th>
                                                        <th>Receiver</th>
                                                        {!exportModal &&
                                                        <>
                                                        <th>Views</th>
                                                        <th>Actions</th>
                                                        <th>Decline</th>
                                                        </>
                                                        }
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {pageOfItems.length > 0 ?
                                                        pageOfItems.map((req, id) => {
                                                            return (
                                                                <tr key={id}>
                                                                    <td>{req.Id} </td>
                                                                    <td><span className="statusconform"
                                                                        title={req.awaitingApprovalStatus === "Pending" ? "Awaiting approval by practice" : req.awaitingApprovalStatus === "Denied" ? "Declined" : req.requestStatus == "Requested" ? "Records Requested" : req.requestStatus == "Pending" ? "Payment Pending" : req.requestStatus == "Completed" ? "Payment Completed Records are Ready" : ""} >
                                                                        {req.awaitingApprovalStatus === "Pending" ? "AA" : req.awaitingApprovalStatus === "Denied" ? "D" : req.requestStatus == "Requested" ? "R" : req.requestStatus == "Pending" ? "P" : req.requestStatus == "Completed" ? "C" : ""}</span></td>
                                                                    <td>{moment(req.createdDate).format('MMM Do YYYY')} </td>
                                                                    {/*06June2019 without kurra,added below condtion*/}
                                                                    <td>{req.requestStatus == "Completed" ? moment(req.dateOfRequestCompleted).format('MMM Do YYYY') : "-"} </td>
                                                                    <td>{req.requestedBy}</td>
                                                                    <td>{req.receiverInfoDTO.firstName} {req.receiverInfoDTO.lastName}</td>

                                                                    {!exportModal &&
                                                                    <>
                                                                    <td><button onClick={(e) => this.viewDetails(e, req)} className="icon view-icon-emp-design" title="View full info"><i className="fa fa-eye" aria-hidden="true"></i></button></td>


                                                                    {req.awaitingApprovalStatus ?
                                                                        <td>
                                                                            <button
                                                                                disabled={req.awaitingApprovalStatus === "Pending" ? false : req.awaitingApprovalStatus === "Approved" ? true : req.awaitingApprovalStatus === "Denied" ? true : ""}
                                                                                onClick={() => this.openPopDel(req.Id)} className="action-btn" >
                                                                                {req.awaitingApprovalStatus === "Pending" ? "Approve" : req.awaitingApprovalStatus === "Approved" ? "Approved" : req.awaitingApprovalStatus === "Denied" ? "Approve" : ""}
                                                                            </button> </td>
                                                                        : <td></td>
                                                                    }
                                                                    {req.awaitingApprovalStatus ?
                                                                        <td><button className="action-btn"
                                                                            disabled={req.awaitingApprovalStatus === "Pending" ? false : req.awaitingApprovalStatus === "Approved" ? true : req.awaitingApprovalStatus === "Denied" ? true : ""}

                                                                            onClick={() => this.openPopDecline(req.Id)}   >
                                                                            {req.awaitingApprovalStatus === "Pending" ? "Decline" : req.awaitingApprovalStatus === "Denied" ? "Declined" : req.awaitingApprovalStatus === "Approved" ? "Decline" : ""}</button></td>
                                                                        : <td></td>
                                                                    }
                                                                    </>
                                                                    }

                                                                </tr>
                                                            )
                                                        }) : <tr style={{ background: "transparent" }}><td colspan="6"><img src="images/no-record-found.png" width="180px" style={{ opacity: "0.6" }} /></td></tr>

                                                    }


                                                </tbody>
                                            </table>
                                        </div>

                                        <Pagination items={facilityReqInfoList} onChangePage={this.onChangePage} />


                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <DeleteModel header="Approve" text="Are you sure you want to approve?" page="approvepractice" status={this.state.openPopUpDel} confirmOkay={() => this.approveStatus(this.state.requestId)} closePop={this.closePopDel} />
                <DeleteModel header="Decline" text="Are you sure you want to Decline?" page="declinePractice" status={this.state.openPopUpDecline} confirmOkay={() => this.declineStatus(this.state.requestId)} closePop={this.closePopDecline} />

                <Footer />

                {this.state.exportModal &&
          <>
            <div class="modal fade in " id="editdata" role="dialog">
              <div class="modal-dialog">

                <div class="modal-content">
                <div class="modal-header">
                <h4 class="modal-title">Export</h4>
                                         <button type="button" class="close" onClick={()=>this.setState({exportModal : false})}   >&times;</button>
                                    </div>
                  <div class="modal-body mod-body">
                    <h5 >Please click on Export button to download Xls sheet</h5>

                     <ReactHTMLTableToExcel
                                            id="test-table-xls-button"
                                            className="btn submit-btn"
                                            table="table-to-xls"
                                            filename="reports"
                                            sheet="reports"
                                            buttonText="Export" />
                  
                  </div>
                  <div class="model-btn text-center mb-3">
                    
      
                    

                    
                  </div>
                </div>



              </div>

            </div>
          </>
        }

                {this.state.openPopUp &&
                    <div class="creatTasks">
                        <div class="modal fade in " id="createtask" role="dialog">
                            <div class="modal-dialog">
                                <div class="modal-content bill-model-design">
                                    <div class="modal-header">
                                        <h4 class="modal-title">Requested Record Details</h4>
                                        <button type="button" class="close" onClick={() => { this.setState({ openPopUp: false }) }} >&times;</button>
                                    </div>

                                    <div class="modal-body">

                                        <div class="createtaskbody ">
                                            <div class="bgdefet">
                                                <div class="row">
                                               
                                                    <div>

                                                        <label className="fw600 title-model-color mt-2">Requestor Details</label>
                                                        <table className="modal-table-design">
                                                             {reqUserType === 'other' && thirdPartyRequestId !=="" &&
                                                              <tr>
                                                                <td className="model-td-design"> <label class="fw600">Third Party Request Id</label></td>
                                                                <td className="model-td-design"> <label>{thirdPartyRequestId} </label>  </td>
                                                            </tr>
                                                             }
                                                            <tr>
                                                                <td className="model-td-design"> <label class="fw600">Requestor Name</label></td>
                                                                <td className="model-td-design"> <label>{patientName} </label>  </td>
                                                            </tr>
                                                            
                                                            {reqUserType !== 'other' &&
                                                                <tr>
                                                                    <td> <label class="fw600">Date of birth</label></td>
                                                                    <td> <label>{dateOfBirth} </label>  </td>
                                                                </tr>
                                                            }

                                                            <tr>
                                                                <td className="model-td-design">  <label class="fw600">Phone No</label></td>

                                                                <td className="model-td-design"> <label>{patientPhone} </label>  </td>
                                                            </tr>
                                                              <tr>
                                                                <td className="model-td-design">  <label class="fw600">Requested date</label></td>
                                                                <td className="model-td-design"> <label>{createdDate}</label>  </td>
                                                            </tr>
                                                        </table>

                                                    </div>

                                                    <div>

                                                        <label className="fw600 title-model-color">Requested Records Details</label>
                                                        <ol>
                                                            {this.state.records.map((item, id) => {
                                                                return (

                                                                    <li key={id}>{item.recordName}</li>


                                                                )
                                                            })
                                                            }

                                                        </ol>
                                                    </div>


                                                    {otherRequestorDocURL &&
                                                        <div className="bgdefet1">
                                                            <h4 className="pract1">Document</h4>
                                                            <div  >
                                                                <iframe title="titleOne" src={otherRequestorDocURL} style={{ width: "100%", height: "100vh" }} ></iframe>

                                                            </div>
                                                            {/* <button class="btnDefault"><a href={otherRequestorDocURL} target="_blank"  rel="noopener noreferrer"  download> Download</a></button> */}
                                                        </div>
                                                    }

                                                </div>
                                            </div>




                                        </div>
                                        <div class="bgdefet">
                                            <div class="modal-footer1">
                                                <button type="button" onClick={() => { this.setState({ openPopUp: false }) }} class="btngeo clearbtn">Close</button>
                                                {/* <button type="button"  onClick={()=>{this.setState({openPopUp:false})}} class="btngeo submitbtn clr448aff" data-dismiss="modal">Submit</button> */}

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }

            </>
        )
    }
}
const mapStateToProps = state => ({
    profileDetails: state.commonReducer.profileDetails,
    loginDetails: state.commonReducer.loginDetails,
    facilityReqInfoList: state.facilityReducer.facilityReqInfoList,
    facilityReqInfoStatus: state.facilityReducer.facilityReqInfoStatus,
    viewRequestInfoStatus: state.commonReducer.viewRequestInfoStatus,
    viewRequestInfoDetails: state.commonReducer.viewRequestInfoDetails,

});
const mapDispatchToProps = dispatch => ({
    getFacilityRecordReqList: (token, userId, ) => dispatch(getFacilityRecordReqList(token, userId)),
    viewRequestInfo: (token, payload, ) => dispatch(viewRequestInfo(token, payload)),
    approveStatus: (token, id, userId) => dispatch(approveStatus(token, id, userId)),
    declineStatus: (token, id, userId) => dispatch(declineStatus(token, id, userId)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(withRouter(FacilityHome));